
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFA329"}},[_c('path',{attrs:{"d":"M6.501 22.5c-.827 0-1.5-.673-1.5-1.5v-9.5h-1a.534.534 0 01-.069-.005.802.802 0 00-.235 0 .825.825 0 00-.701.935.552.552 0 01.005.071v8a.5.5 0 01-1 0v-7.967a1.833 1.833 0 012.033-2.033h15.935a1.804 1.804 0 01.477.005c.483.069.91.322 1.203.712.285.38.409.846.352 1.316V20.5a.5.5 0 01-1 0v-8a.58.58 0 01.005-.072.82.82 0 00-.157-.611.82.82 0 00-.777-.322.55.55 0 01-.07.005h-1V21c0 .827-.673 1.5-1.5 1.5H6.501zm-.5-1.5a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-9.5h-12V21zM6.164 9.5a.99.99 0 01-.895-.557.992.992 0 01-.051-.763 6.982 6.982 0 014.77-4.431L8.673 2.346a.5.5 0 01.729-.684l1.757 1.873a6.99 6.99 0 01.859-.035l.117-.001c.231 0 .467.012.717.038l1.759-1.875a.503.503 0 01.707-.023.5.5 0 01.023.707l-1.319 1.406a6.985 6.985 0 014.755 4.413 1.004 1.004 0 01-.235 1.042.997.997 0 01-.708.293H6.164zm4.763-4.929a6.022 6.022 0 00-4.765 3.937L17.834 8.5a6.034 6.034 0 00-4.762-3.927c-.011.001-.025.003-.039.003a.48.48 0 01-.165-.03 6.193 6.193 0 00-.744-.047l-.107.001-.159-.002c-.216 0-.448.015-.708.046a.491.491 0 01-.17.032.273.273 0 01-.053-.005z"}}),_c('circle',{attrs:{"cx":"10.251","cy":"6.75","r":".75"}}),_c('circle',{attrs:{"cx":"13.751","cy":"6.75","r":".75"}})])])
          )
        }
      }
    